
export const getFirefoxCssFix = (key: string): string | null => {
    const isFirefox = (): boolean => {
      return navigator.userAgent.toLowerCase().includes("firefox");
    };
  
    if (isFirefox()) {

        switch (key) {
            case 'scroll':
                return 'firefoxScroll'
            case 'tableBorder' : 
                    return ' border border-primary_text '
            default:
                break;
        }
    } else {
        switch (key) {
            case 'scroll':
                return 'scrollBar'   
            case 'tableBorder':
                return "border border-y"     
            default:
                break;
        }
    }
  
    // Return null if not Firefox
    return null;
  };
  